module.exports = __webpack_public_path__ + "img/cn.f6dc9d33.png";